var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"target",staticClass:"mouse-changer",on:{"mouseenter":_vm.onMouseEnter,"mouseover":_vm.onMouseEnter,"mouseleave":_vm.onMouseLeave,"mouseout":_vm.onMouseLeave,"mouseup":_vm.onMouseLeave}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }